import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AdminPortal, AdminSubmissionDetailPage } from "./components/app/admin";
import { AssessmentPage } from "./components/app/assessment";
import { AuthProvider, RequireAuth } from "./components/app/auth";
import { ClientPortal } from "./components/app/client";
import { AboutPage, ContactPage, EducationPage, HomePage, LoginPage, RegisterPage, ServicesPage, SiteLayout, TestsPage } from "./components/app/site";
import "./index.css";

function AppRoutes() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route index element={<HomePage />} />
        <Route path="layanan" element={<ServicesPage />} />
        <Route path="tes" element={<TestsPage />} />
        <Route path="edukasi" element={<EducationPage />} />
        <Route path="tentang" element={<AboutPage />} />
        <Route path="kontak" element={<ContactPage />} />
        <Route path="masuk" element={<LoginPage />} />
        <Route path="daftar" element={<RegisterPage />} />
      </Route>
      <Route
        path="portal"
        element={
          <RequireAuth roles={["client"]}>
            <ClientPortal />
          </RequireAuth>
        }
      />
      <Route
        path="portal/asesmen/:id"
        element={
          <RequireAuth roles={["client"]}>
            <AssessmentPage />
          </RequireAuth>
        }
      />
      <Route
        path="admin"
        element={
          <RequireAuth roles={["admin", "psychologist"]}>
            <AdminPortal />
          </RequireAuth>
        }
      />
      <Route
        path="admin/submissions/:id"
        element={
          <RequireAuth roles={["admin", "psychologist"]}>
            <AdminSubmissionDetailPage />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
